import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      backgroundColor: "white",
      height: "100%",
      minHeight: "100vh",
    },
    body: {
      maxWidth: "80vw",
      width: "100%",
      margin: "auto",
      marginBottom: 48,
      [theme.breakpoints.down(460)]: {
        maxWidth: "90vw",
      },
    },
    hero: {
      padding: "120px 0px",
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 48,
      [theme.breakpoints.down(1024)]: {
        flexDirection: "column",
        alignItems: "flex-start",
      },
    },
    hotelName: {
      marginBottom: 16,
    },
    hotelImageWrapper: {
      width: "60%",
      [theme.breakpoints.up(1440)]: {
        width: "50%",
      },
      [theme.breakpoints.down(1024)]: {
        width: "100%",
        order: -1,
      },
    },
    hotelImage: {
      width: "100%",
      height: 400,
      objectFit: "cover",
      borderRadius: 16,
    },
    selectCheckinCheckoutWrapper: {
      width: "100%",
      backgroundColor: theme.palette.primary.light,
      padding: 48,
      borderRadius: 24,
      [theme.breakpoints.down(426)]: {
        padding: 32,
      },
    },
  })
);

export default useStyles;
